module.exports = __webpack_public_path__ + "img/truck.1e9b1bc4.png";